import React from 'react';
import { Menu, Popover } from 'antd';
import { useHistory } from "react-router-dom";

export default function SideMenu({params}) {

    let history = useHistory();

    function handleClick(e){
		let current = e.key;
		switch (current) {
			case "1":
				history.push("/");
				break;
			case "2":
				history.push("/tool02");
				break;
			case "3":
				history.push("/tool03");
				break;
			case "4":
				history.push("/tool04");
				break;

            case "5":
				history.push("/tool05");
				break;

            case "6":
				history.push("/tool06");
				break;
			case "7":
				history.push("/tool07");
				break;
			case "8":
				history.push("/tool08");
				break;
			case "9":
				history.push("/tool09");
				break;

            case "10":
				history.push("/tool10");
				break;
		
			default:
				break;
		}

	}
    return (
        <Menu
            onClick={handleClick}
            defaultSelectedKeys={params}
            mode="inline"
            style={{ height: '100%' }}
        >
            <Menu.ItemGroup key="g1">
                <Menu.Item key="1">
					<Popover placement="rightBottom" content={<div><p>查找连续指示子串在序列中的位置</p></div>} trigger="hover">DNA模式查找</Popover>
				</Menu.Item>
                <Menu.Item key="2">
					<Popover placement="rightBottom" content={<div><p>在随机位置突变指定数量个碱基</p></div>} trigger="hover">DNA突变</Popover>
				</Menu.Item>
                <Menu.Item key="3">
					<Popover placement="rightBottom" content={<div><p>将输入的序列折叠成相等的几串,不够均分剩余的序列将组成一串</p></div>} trigger="hover">FASTA拆分</Popover>
				</Menu.Item>
                <Menu.Item key="4">
					<Popover placement="rightBottom" content={<div><p>合并给定的若干条FASTA序列</p></div>} trigger="hover">FASTA合并</Popover>
				</Menu.Item>
                <Menu.Item key="5">
					<Popover placement="rightBottom" content={<div><p>统计给定序列的密码子频度</p></div>} trigger="hover">按密码子拆分DNA</Popover>
				</Menu.Item>
                <Menu.Item key="6">
					<Popover placement="rightBottom" content={<div><p>给定几条序列 在不改变碱基对组成的情况下打乱序列</p></div>} trigger="hover">打乱蛋白质</Popover>
				</Menu.Item>
                <Menu.Item key="7">
					<Popover placement="rightBottom" content={<div><p>在随机位置突变指定数量个碱基</p></div>} trigger="hover">蛋白质突变</Popover>
				</Menu.Item>
                <Menu.Item key="8">
					<Popover placement="rightBottom" content={<div><p>随机生成DNA数组</p></div>} trigger="hover">随机DNA</Popover>
				</Menu.Item>
				<Menu.Item key="9">
					<Popover placement="rightBottom" content={<div><p>随机生成蛋白质数组</p></div>} trigger="hover">随机蛋白质</Popover>
				</Menu.Item>
                
            </Menu.ItemGroup>
        </Menu>
        
    )
}